import { createFileRoute, Outlet } from "@tanstack/react-router";

import { NavStackProvider } from "@/utils/useNavStack";

export const Route = createFileRoute("/_auth/_app/accessions")({
  component: AccessionsRoot,
});

function AccessionsRoot() {
  return (
    <NavStackProvider label="Accessions" href={{ to: "/accessions" }}>
      <Outlet />
    </NavStackProvider>
  );
}
